import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { LayerNotifier } from './layer-notifier';
import { LayerState } from './layer-state';

@Injectable()
export class LayerProvider extends BaseProvider<LayerNotifier, LayerState> {
  constructor() {
    super(LayerNotifier);
    this.trackSessionReset(() => this.notifier.resetState());
  }
}
